<template>
    <div>
        <firstSection></firstSection>
        <Sectiontwo></Sectiontwo>
        <ThirdSection></ThirdSection>
        <!--<Testimonials></Testimonials>-->
        <FourthSection></FourthSection>
        <FifthSection></FifthSection>
        <SixthSection></SixthSection>
        <SolutionSection></SolutionSection>
        <MissionsSection></MissionsSection>
        <firstService></firstService>
        <secondService></secondService>
        <thirdService></thirdService>
        <equipe></equipe>
        <Footer></Footer>
    </div>
</template>

<script>

import FirstSection from './firstScetion/firstSection.vue';
import Sectiontwo from './SectionTwo/SectionTwo.vue';
import ThirdSection from './ThirdSection/ThirdSection.vue';
//import Testimonials from './Testimonials/Testimonials.vue';
import FourthSection from './FourthSection/FourthSection.vue';
import FifthSection from './FifthSection/FifthSection.vue';
import SixthSection from './SixthSection/SixthSection.vue';
import SolutionSection from './propos/solutionSection/solution.vue';
import MissionsSection from './propos/missionsSection/missions.vue';
import firstService from './NosServices/firstService/firstService.vue';
import secondService from './NosServices/secondService/secondService.vue';
import thirdService from './NosServices/thirdService/thirdService.vue';
import equipe from './propos/equipe/equipe.vue';
import Footer  from '@/components/footer.vue';

export default {
    name: 'Home',
    components: {
        FirstSection,
        Sectiontwo,
        ThirdSection,
        //Testimonials,
        FourthSection,
        FifthSection,
        SixthSection,
        Footer,
        SolutionSection,
        MissionsSection,
        firstService,
        secondService,
        thirdService,
        equipe
    },
};
</script>

<style scoped>
/* Add your styles here */
</style>

<style scoped>
/* Add your styles here */
</style>
